var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"center-valid"},[(_vm.checked)?_c('div',[_vm._v(" ¡Autenticado! Pincha "),_c('a',{attrs:{"href":_vm.$router.resolve({
            name: 'LoginPage',
          }).href}},[_vm._v("aquí")]),_vm._v(" para iniciar sesión en tu empresa. ")]):_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }